import { createAsyncThunk } from '@reduxjs/toolkit';
import { insertQuestionnaireRequest } from '../api';

export const insertQuestionnaire = createAsyncThunk(
  'INSERT_QUESTIONNAIRE',
  insertQuestionnaireRequest,
);
